import { Link } from '@tanstack/react-router'
import { Container, Wordmark } from './primitives'

export function Footer() {
  return (
    <footer style={{ padding: '40px 0 56px', borderTop: '1px solid var(--line)' }}>
      <Container
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <Wordmark />
          <span
            style={{
              fontSize: 13,
              color: 'var(--muted)',
              fontFamily: 'var(--mono)',
            }}
          >
            © 2026
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 24,
            fontSize: 13,
            color: 'var(--muted)',
            flexWrap: 'wrap',
          }}
        >
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <a href="mailto:hello@withvello.com">hello@withvello.com</a>
        </div>
      </Container>
    </footer>
  )
}
